import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";

const PlatformQueryWrapper = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasNavigated = useRef(false);

  useEffect(() => {
    const currentSearchParams = new URLSearchParams(location.search);
    const isAlreadyPremium = currentSearchParams.get("platform") === "premium";

    if (isAlreadyPremium) return;

    if (!hasNavigated.current) {
      hasNavigated.current = true;

      const referrer = document.referrer;
      const referrerUrl = new URL(referrer, window.location.origin);
      const referrerParams = new URLSearchParams(referrerUrl.search);
      const wasPremium = referrerParams.get("platform") === "premium";

      if (wasPremium) {
        currentSearchParams.set("platform", "premium");

        const hasOtherParams = location.search && location.search !== "?";
        const separator = hasOtherParams ? "&" : "?";
        const hash = location.hash || "";

        const newUrl = `${location.pathname}${separator}${currentSearchParams.toString()}${hash}`;
        navigate(newUrl, { replace: true });
      }
    }
  }, [location, navigate]);

  return <>{children}</>;
};

export default PlatformQueryWrapper;
